
const m = window.require("@ember/template");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
